export function AhumLogo() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M33.1719 25.8235V18.1546C33.1719 14.3469 30.6828 3.25781 15.717 3.25781H15.4502C7.24413 3.25781 0.567993 9.93395 0.567993 18.1401V21.6682C0.567993 29.8744 7.24413 36.5505 15.4502 36.5505H15.717C21.9286 36.5505 25.641 33.3154 28.0403 29.5567C29.4196 33.1929 32.4269 36.7365 37.3898 36.7365H37.5567C43.5741 36.7365 33.1719 36.7365 33.1719 25.8235Z" fill="#F5315C"/>
    </svg>
  );
}
